<template>
  <Card class="sum-card-box2" :padding="0" style="background: #fff">
    <div class="header_box">
      <!-- <div class="header_br"></div> -->
      <div class="header_title">快捷入口</div>
    </div>
    <div class="box1">
      <div class="item" @click="goPage(5)" v-if="this.a === true">
        <img class="image" src="../../../assets/img/work_2.png" />
        <div class="title">呼叫中心</div>
      </div>

      <div class="item" @click="goPage(1)" v-if="this.e === true">
        <img class="image" src="../../../assets/img/work_3.png" />
        <div class="title">查询工单</div>
      </div>

      <div class="item" @click="goPage(4)" v-if="this.d === true">
        <img class="image" src="../../../assets/img/work_4.png" />
        <div class="title">快速建单</div>
      </div>

      <div class="item" @click="goPage(6)" v-if="this.f === true">
        <img class="image" src="../../../assets/img/work_5.png" />
        <div class="title">常用语句</div>
      </div>

      <div class="item" @click="goPage(3)" v-if="this.c === true">
        <img class="image" src="../../../assets/img/work_6.png" />
        <div class="title">资产管理</div>
      </div>

      <div class="item" @click="goPage(7)" v-if="this.g === true">
        <img class="image" src="../../../assets/img/work_7.png" />
        <div class="title">耗材领用</div>
      </div>
      <!--
      <div class="item" @click="goPage(8)" v-if="this.h === true">
        <img class="image" src="../../../assets/img/work_8.png" />
        <div class="title">物资商城</div>
      </div> -->

      <div class="item" @click="goPage(9)" v-if="this.j === true">
        <img class="image" src="../../../assets/img/work_9.png" />
        <div class="title">科室管理</div>
      </div>

      <div class="item" @click="goPage(10)" v-if="this.k === true">
        <img class="image" src="../../../assets/img/work_1.png" />
        <div class="title">人员管理</div>
      </div>

      <!--              <div class="item" @click="goPage(2)" v-if="this.b === true">-->
      <!--                <img class="image" src="../../../assets/img/work_3.png" />-->
      <!--                <div class="title">查询巡检</div>-->
      <!--              </div>-->
    </div>
  </Card>
</template>
<script>
export default {
  name: 'enter',
  components: {},
  data() {
    return {
      a: "",
      b: "",
      c: "",
      d: "",
      e: "",
      f: "",
      g: "",
      h: "",
      j: "",
      k: "",
    };
  },
  computed: {
    isSystem() {
      return $utils.data.get('auth', 'is_system') || false
    },
  },
  created() {
    let arr = $utils.data.get("auth", "auths");
    this.a = arr.some(function (item) {
      if (item.url == "system/processing/index") {
        return true; //返回false
      }
    });
    this.b = arr.some(function (item) {
      if (item.url == "system/inspection/index") {
        return true; //返回false
      }
    });
    this.c = arr.some(function (item) {
      if (item.url == "system/device/index") {
        return true; //返回false
      }
    });
    this.d = arr.some(function (item) {
      if (item.url == "system/workOrder/add") {
        return true; //返回false
      }
    });
    this.e = arr.some(function (item) {
      if (item.url == "system/workOrder/index") {
        return true; //返回false
      }
    });
    this.f = arr.some(function (item) {
      if (item.url == "system/commondescr/index") {
        return true; //返回false
      }
    });
    this.g = arr.some(function (item) {
      if (item.url == "system/consumablesrecord/index") {
        return true; //返回false
      }
    });
    this.h = arr.some(function (item) {
      if (item.url == "/admin/hospitalbackstage/list") {
        return true; //返回false
      }
    });
    this.j = arr.some(function (item) {
      if (item.url == "system/offices/index") {
        return true; //返回false
      }
    });
    this.k = arr.some(function (item) {
      if (item.url == "/admin/authaccess/lists") {
        return true; //返回false
      }
    });
  },
  methods: {
    goPage(val) {
      if (val == 1) {
        $utils.url.push({
          name: 'processing_list',
        })
      } else if (val == 2) {
        $utils.url.push({
          name: 'inspection_list',
        })
      } else if (val == 3) {
        $utils.url.push({
          name: "deviceretrieval_list",
        });
      } else if (val == 4) {
        $utils.url.push({
          name: "workOrder_add",
          query: { action: "add", kv: "flash", msgkv: "flashadd" },
        });
      } else if (val == 5) {
        $utils.url.push({
          name: "callcenter_list",
        });
      } else if (val == 6) {
        $utils.url.push({
          name: "commondescr_list",
        });
      } else if (val == 7) {
        $utils.url.push({
          name: 'record_list',
        })
      }else if (val == 8) {
        $utils.url.push({
          name: "hospitalbackstage",
        });
      } else if (val == 9) {
        $utils.url.push({
          name: "offices_list",
        });
      } else if (val == 10) {
        $utils.url.push({
          name: "repairman_list",
        });
      }
    },
  },
}
</script>
<style lang="less" scoped>

.sum-card-box2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;
  padding-top: 10px;
  //padding: 20px 24px 8px;
  .header_box {
    display: flex;
    align-items: center;
  }
  .header_br {
    width: 4px;
    height: 20px;
    background-color: #0f47c0;
  }
  .header_title {
    font-family: SourceHanSansSC;
    font-weight: 700;
    font-size: 15px;
    color: rgb(16, 16, 16);
    font-style: normal;
    letter-spacing: 0px;
    text-decoration: none;
    margin-left: 10px;
  }
  .item3 {
    height: 0px;
    margin-bottom: 2px;
    width: 100%;
  }
  .item4 {
    border-top: 1px solid #e8e8e8;
    padding-top: 5px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    span:last-child {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
.box1 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content:space-around;
  .item {
    align-items: center;
    margin: 10px 15px;
    cursor: pointer;
    .image {
      width: 40px;
      height: 40px;
      display: block;
      margin-left: 10px;
      // background: #ccc;
    }
    .title {
      font-family: SourceHanSansSC;
      font-weight: 400;
      font-size: 14px;
      color: rgb(16, 16, 16);
      font-style: normal;
      margin-top: 10px;
    }
  }
}
</style>
